module.exports = __webpack_public_path__ + "snd/48987d51eb2864e7d7ae66b3d54d42d2.wav";